export default "__VITE_ASSET__D3usX0oK__"